import { render } from "./verify-email-succ.vue?vue&type=template&id=504ce6a9&ts=true"
import script from "./verify-email-succ.vue?vue&type=script&lang=ts"
export * from "./verify-email-succ.vue?vue&type=script&lang=ts"

import "./verify-email-succ.vue?vue&type=style&index=0&id=504ce6a9&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__